/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function transportTypes(instance) {
	return {
		/**
		 * @param {number} transportTypeId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (transportTypeId, config = {}) => {
			return instance.get(`transport_types/${transportTypeId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`transport_types${params}`, config)
		},

		/**
		 * @param {number} transportTypeId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (transportTypeId, body, config = {}) => {
			return instance.put(`transport_types/${transportTypeId}`, body, config)
		},

		/**
		 * @param {number} transportTypeId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (transportTypeId, config = {}) => {
			return instance.delete(`transport_types/${transportTypeId}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('transport_types', body, config)
		}
	}
}
